module.exports = __webpack_public_path__ + "img/18.a1af10b5.jpg";